import { CircleDangerLevelComponent } from './circle-danger-level.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [CircleDangerLevelComponent],
  imports: [CommonModule],
  exports: [CircleDangerLevelComponent],
})
export class CircleDangerLevelModule {}
